import React, { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import imagePng from "images/space2.jpg";

export interface SectionHero3Props {
  className?: string;
}

const SectionHero3: FC<SectionHero3Props> = ({ className = "" }) => {
  return (
    <div
      className={`nc-SectionHero3 relative ${className} min-h-screen w-full`}
      data-nc-id="SectionHero3"
      style={{
        // position: "fixed"
      }}
    >
      {/* Overlay content */}
      <div className="absolute z-10 inset-x-0 top-[20%] sm:top-[20%] text-center flex flex-col items-center max-w-2xl mx-auto space-y-4 lg:space-y-5 xl:space-y-8">
        <span className="sm:text-lg md:text-xl font-semibold text-white">
          NAROSTP
        </span>
        <h2 className="font-bold text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl !leading-[115%] ">
          Re-defining <br /> the Newspace
        </h2>
        <ButtonPrimary
          sizeClass="px-6 py-3 lg:px-8 lg:py-4 rounded-xl"
          fontSize="text-sm sm:text-base lg:text-lg font-medium"
        >
          Find the Difference and Enjoy!
        </ButtonPrimary>
      </div>

      {/* Fullscreen background image */}
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src={imagePng}
          alt="hero"
        />
      </div>
    </div>
  );
};

export default SectionHero3;